// eslint-disable-next-line import/prefer-default-export
export const DaysOfWeekNames = Object.freeze([
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
]);
